module.exports = __webpack_public_path__ + "static/media/koczer_logo_white.a2dc5337.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/koczer_logo_white.svg
// module id = 1411
// module chunks = 0